export default function CloseIconNewVegas() {
  return (
    <svg
      data-testid="close-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M15.5746 15.3182C15.0074 15.8854 14.0879 15.8854 13.5207 15.3182L8.12819 9.92569L2.47929 15.5746C1.91208 16.1418 0.992624 16.1418 0.42541 15.5746C-0.141803 15.0074 -0.141803 14.0879 0.42541 13.5207L6.07431 7.87181L0.681782 2.47929C0.114568 1.91208 0.114568 0.991898 0.681782 0.42541C1.249 -0.141803 2.16845 -0.141803 2.73566 0.42541L8.12819 5.81793L13.2636 0.682508C13.8308 0.115295 14.7503 0.115295 15.3175 0.682508C15.8847 1.24972 15.8847 2.16917 15.3175 2.73639L10.1821 7.87181L15.5746 13.2643C16.1418 13.8316 16.1418 14.751 15.5746 15.3182Z"
        fill="currentColor"
      />
    </svg>
  );
}
